import React, { useState, useEffect } from "react";
import Header from "../../components/header/index.js";
import LeftMenu from "../../components/left-menu/index.js";
import { useSelector } from 'react-redux';
import {useNavigate} from "react-router-dom";
import Grid from '@mui/material/Grid';
import {readEmpty} from "../SalesMeeting/apiEmpty.js";
import "./style.css";
import { DatePicker } from '@mui/x-date-pickers';
import { Select, MenuItem } from '@mui/material';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { MobileDatePicker } from '@mui/x-date-pickers/MobileDatePicker';
import InputAdornment from '@mui/material/InputAdornment';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import TableBody from '@mui/material/TableBody';
import axios from "axios";
import Button from '@mui/material/Button';
import { Typography, Dialog, LinearProgress, DialogContent, Box, Card } from "@mui/material";
import TextField from '@mui/material/TextField';
import Autocomplete from "@mui/material/Autocomplete";
import CheckIcon from "@mui/icons-material/Check";
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import {Switch} from "@mui/material";

export default function LegalProcess() {
    const [selectedSource, setSelectedSource] = useState('All');
    const [selectedStartDate, setSelectedStartDate] = useState(new Date());
    const [selectedEndDate, setSelectedEndDate] = useState(new Date());
    const [data, setData] = useState([]);
    const formatDate = (dateString) => {
        if (!dateString) return '';
        const date = new Date(dateString);
        return new Intl.DateTimeFormat('en-GB').format(date); // Format date as DD/MM/YYYY
      };
      
    const fetchData = () => {
        axios.get(`${process.env.REACT_APP_BACKEND_URL}/inquiryReview`, {
            params: {
                source: selectedSource,
                startDate: selectedStartDate.toISOString(),
                endDate: selectedEndDate.toISOString()
            }
        })
            .then(response => {
                console.log(response.data)
                setData(response.data);
            })
            .catch(error => {
                console.error('Error fetching data:', error);
            });
    };
    const findRecentActivity = (history) => {
        if (!history || !Array.isArray(history)) return 'N/A';
        for (let i = history.length - 1; i >= 0; i--) {
          if (history[i].Stat === 'Done FU' || history[i].Stat === 'Drop') {
            return history[i].Activity || 'N/A';
          }
        }
        return 'N/A';
      };

      const findStatus = (data) => {
        if (data?.PaidPILink === 'Yes') {
          return 'Paid';
        }
      
        if (data?.remindDate) {
          if (data.remindDate === 'Drop') {
            return 'Drop';
          }
      
          const date = new Date(data.remindDate);
          const formattedDate = `${String(date.getDate()).padStart(2, '0')}/${String(date.getMonth() + 1).padStart(2, '0')}/${date.getFullYear()}`;
          return `Remind lagi ${formattedDate}`;
        }
      
        return 'N/A';
      };
      

      const findRecentUpdate = (data) => {
        if (data?.newStat === 'New') {
          return 'New';
        }
        
        if (data?.doneDate) {
          const date = new Date(data.doneDate);
          const formattedDate = `${String(date.getDate()).padStart(2, '0')}/${String(date.getMonth() + 1).padStart(2, '0')}/${date.getFullYear()}`;
          return formattedDate;
        }
      
        return 'N/A';
      };
      
      const findRecentNotes = (history) => {
        if (!history || !Array.isArray(history)) return 'N/A';
        for (let i = history.length - 1; i >= 0; i--) {
          if (history[i].Stat === 'Done FU' || history[i].Stat === 'Drop') {
            return history[i].Keterangan || 'N/A';
          }
        }
        return 'N/A';
      };

    useEffect(() => {
        fetchData();
    }, [selectedSource, selectedStartDate, selectedEndDate]);

    const handleSourceChange = (event) => {
        setSelectedSource(event.target.value);
      };

    const handleDateChangeStart = (newDate) => {
        setSelectedStartDate(newDate);
    };
    const handleDateChangeEnd = (newDate) => {
        setSelectedEndDate(newDate);
    };

    const findSource = (item) => {
        if (item?.chatLink?.includes('my.livechatinc.com')) {
          return 'Google';
        }
        if (item?.chatLink?.includes('chat.qontak.com')) {
          return 'Facebook';
        }
        if (item?.Iklan && Array.isArray(item.Iklan) && item.Iklan.length > 0) {
          return item.Iklan.join(', '); // Join Iklan array items into a single string
        }
        return 'Undefined';
      };
      
    
    return (
        <Grid container>   
            <Grid item  xl={0.5} lg={0.7} md={0.9} sm={3.2} className="leftmenucolor">
                <LeftMenu/>
            </Grid>
            <Grid xl={11.5} lg={11.3} md={10.4} sm={8.8} sx={{py:10, px:10}}>
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                <Grid container>
                    <Grid xs={2}>
                        <Select
                        labelId="person-select-label"
                        id="person-select"
                        value={selectedSource}
                        onChange={handleSourceChange}
                        label="Select Person"
                        >
                            <MenuItem value="All">All</MenuItem>
                            <MenuItem value="Google">Google</MenuItem>
                            <MenuItem value="Facebook">Facebook</MenuItem>
                            <MenuItem value="Others">Others</MenuItem>
                        </Select>
                    </Grid>
                    <Grid xs={3}>
                        <DatePicker
                            label="Start Date"
                            value={selectedStartDate}
                            onChange={handleDateChangeStart}
                            renderInput={(params) => <TextField {...params} fullWidth />}
                        />
                    </Grid>
                    <Grid item xs={1} container alignItems="center" justifyContent="center">
                    to
                </Grid>
                    <Grid xs={3}>
                        <DatePicker
                            label="End Date"
                            value={selectedEndDate}
                            onChange={handleDateChangeEnd}
                            renderInput={(params) => <TextField {...params} fullWidth />}
                        />
                    </Grid>
                </Grid>
                </LocalizationProvider>
                <Grid container sx={{py:2}}>
                    <Grid xs={3} sx={{px:1}}>
                    <Card sx={{p:2}}>
                        <Typography sx={{ color: 'text.secondary' }}><b>Inquiry Counter</b></Typography>
                        <Typography sx={{ color: 'text.primary', fontSize: 34, fontWeight: 'medium' }}>{data.inquiryCounter}</Typography>
                        {/* <Typography sx={{
                            color: 'success.dark',
                            display: 'inline',
                            fontWeight: 'bold',
                            mx: 0.5,
                            fontSize: 14,
                        }}> +18.77%</Typography> */}
                        {/* <Typography sx={{ color: 'text.secondary', display: 'inline', fontSize: 14 }}>
                        vs. periode sebelumnya
                        </Typography> */}
                    </Card>
                    </Grid>
                    <Grid xs={3} sx={{px:1}}>
                    <Card sx={{p:2}}>
                        <Typography sx={{ color: 'text.secondary' }}><b>Belum di Handle</b></Typography>
                        <Typography sx={{ color: 'text.primary', fontSize: 34, fontWeight: 'medium' }}>{data.belumDiHandle}</Typography>
                        <Typography sx={{
                            color: 'error.dark',
                            display: 'inline',
                            fontWeight: 'bold',
                            mx: 0.5,
                            fontSize: 14,
                        }}> {((data.belumDiHandle/data.inquiryCounter)*100).toFixed(2)}%</Typography>
                        <Typography sx={{ color: 'text.secondary', display: 'inline', fontSize: 14 }}>
                        belum di handle
                        </Typography>
                    </Card>
                    </Grid>
                    <Grid xs={3} sx={{px:1}}>
                    <Card sx={{p:2}}>
                        <Typography sx={{ color: 'text.secondary' }}><b>Average Quality</b></Typography>
                        <Typography sx={{ color: 'text.primary', fontSize: 34, fontWeight: 'medium' }}>{data.averageQuality}</Typography>
                        <Typography sx={{ color: 'text.secondary', display: 'inline', fontSize: 14 }}>
                        /10
                        </Typography>
                    </Card>
                    </Grid>
                    <Grid xs={3} sx={{px:1}}>
                    <Card sx={{p:2}}>
                        <Typography sx={{ color: 'text.secondary' }}><b>Inquiry Sesuai</b></Typography>
                        <Typography sx={{ color: 'text.primary', fontSize: 34, fontWeight: 'medium' }}>{data.inquiriesSesuai}</Typography>
                        <Typography sx={{
                            color: 'success.dark',
                            display: 'inline',
                            fontWeight: 'bold',
                            mx: 0.5,
                            fontSize: 14,
                        }}> {data.belumDiHandle}</Typography>
                        <Typography sx={{ color: 'text.secondary', display: 'inline', fontSize: 14 }}>
                        belum dinilai
                        </Typography>
                    </Card>
                    </Grid>
                    
                </Grid>

                <Paper sx={{ width: '100%', overflow: 'hidden' }}>
                        <TableContainer sx={{ maxHeight: 300, minHeight: 300 }} className="min-h-screen h-screen overflow-scroll">
                            <Table stickyHeader aria-label="sticky table" className="fixed-table">
                                <TableHead>
                                    <TableRow>
                                        <TableCell>Tanggal</TableCell>
                                        <TableCell>Nomor</TableCell>
                                        <TableCell>Source</TableCell>
                                        <TableCell>Kualitas</TableCell>
                                        <TableCell>Last Activity</TableCell>
                                        <TableCell>Last Update</TableCell>
                                        <TableCell>Notes</TableCell>
                                        <TableCell>Status</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {
                                    data && data.inquiries && data.inquiries.length > 0 ? (
                                        data.inquiries.map((item) => (
                                        <TableRow> {/* Assuming each item has a unique 'id' property */}
                                            <TableCell>{formatDate(item?.InqDate)}</TableCell>
                                            <TableCell>{item?.Phone || ''}</TableCell>
                                            <TableCell>{item?.inqGrade || 'N/A'}</TableCell>
                                            <TableCell>{findSource(item)}</TableCell>
                                            <TableCell>{findRecentActivity(item?.history)}</TableCell>
                                            <TableCell>{findRecentUpdate(item)}</TableCell>
                                            <TableCell>{findRecentNotes(item?.history)}</TableCell>
                                            <TableCell>{findStatus(item)}</TableCell>
                                        </TableRow>
                                        ))
                                    ) : null
                                    }
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Paper>
            </Grid>
        </Grid>
    );
}
